import { styled } from '@mui/material';
import { ReactNode } from 'react';

import { SimpleStatus } from '@app-velocity/common';

import { Button } from '../../Button';

export type ActionButtonProps = {
  children: ReactNode;
  status: SimpleStatus;
  disabled?: boolean;
  onClick: () => void;
};

const getColorByStatus = (status: SimpleStatus) => {
  switch (status) {
    case 'error':
      return 'error';
    case 'success':
      return 'success';
    case 'pending':
      return 'info';
    case 'warning':
      return 'warning';
    default:
      return 'info';
  }
};

const StyledButton = styled(Button)(({ theme }) => ({
  flex: '1 0 40%',
  whiteSpace: 'nowrap',
  fontSize: 11,
  padding: `${theme.spacing(1)} ${theme.spacing(1)}`,
}));

export const ActionButton = ({
  children,
  onClick,
  disabled,
  status,
}: ActionButtonProps) => {
  return (
    <StyledButton
      onClick={onClick}
      disabled={disabled}
      variant="action"
      size="small"
      color={getColorByStatus(status)}
    >
      {children}
    </StyledButton>
  );
};
